import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { autoDiagnose: Boolean };
  static targets = ["placeholder"];

  connect() {
    if (this.autoDiagnoseValue && !this.diagnosed) {
      this.diagnosed = true;
      requestAnimationFrame(() => this.submitDiagnosis());
    }
  }

  submitDiagnosis() {
    const form = this.element.querySelector("form[id^='new_message_']");
    if (!form) return;

    const input =
      form.querySelector("textarea[name='message[content]']") ||
      form.querySelector("input[name='message[content]']");
    if (!input) return;

    if (this.hasPlaceholderTarget) {
      this.placeholderTarget.remove();
    }

    input.value = "What's the issue?";
    form.requestSubmit();
  }
}
